﻿'use strict';

angular.module('ntmApp').directive('moveToLeftFrom', ['$window', '$rootScope', function ($window, $rootScope) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {

            var moveToLeft = function () {
                var width = attr.moveToLeftFrom ? $('#' + attr.moveToLeftFrom).width() :
                                                  $(element).width();

                $(element).css('position', 'absolute');
                $(element).css('right', width + 'px');
            };

            $($window).resize(moveToLeft);
            $rootScope.$on('resizeGridEvent', moveToLeft);
            moveToLeft();
        }
    };
}]);